import React from 'react';
import './Banner.css';

import bannerImg from '../../../assets/images/banner.jpg';
import pbIncImg from '../../../assets/images/pbLogo.png';

const Banner = () => {
  return (
    <div>
      <div className="relative bg-gray-800 bg-transparent">
        <div className="relative sm:absolute w-full h-full flex flex-col-reverse sm:flex-row py-8 px-12">
          <div className="mt-6 sm:mt-0 text-center sm:text-left flex-1 flex flex-col">
            {/* <span className="banner-title">Your Online Machine Shop</span>
            <span className="banner-description">Precision & Specialty Projects</span>
            <span className="banner-description">Rapid Prototypes</span>
            <span className="banner-description">Production Runs</span>
            <span className="banner-description">Design Service</span>
            <span className="banner-description">Total Quality</span> */}
          </div>
          <div className="flex sm:ml-10 absolute bottom-0 right-0 mr-10">
            <img className="self-center bottom-0 image-small" alt="pb-inc" src={pbIncImg} />
          </div>
        </div>
        <img className="hidden sm:block" alt="banner" src={bannerImg} />
      </div>
      <div className="text-center mt-5 mb-5 text-3xl font-extrabold ">Instant Quoting, CNC Machining & 3D Printing</div>
    </div>
  )
}

export default Banner;
